import { Request } from '../../httpClient/serverApi/requests/Request';
import { IGetItemsParams } from '../../httpClient/serverApi/types/IGetItemsParams';
import { IGetItemsResult } from '../../httpClient/serverApi/types/IGetItemsResult';
import { ISchedule } from './ISchedule';

export interface IGetSchedulesResult extends IGetItemsResult {
  schedules: ISchedule[];
}

export class GetSchedulesRequest extends Request<IGetItemsParams, IGetSchedulesResult> {
  constructor(params: IGetItemsParams) {
    super('getSchedules', params);
  }
}
